import { render } from "./Scene.vue?vue&type=template&id=ecec2ca8&scoped=true"
import script from "./Scene.vue?vue&type=script&lang=js"
export * from "./Scene.vue?vue&type=script&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=ecec2ca8&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecec2ca8"]])

export default __exports__